import { render, staticRenderFns } from "./sift.vue?vue&type=template&id=3772b10c&"
import script from "./sift.vue?vue&type=script&lang=js&"
export * from "./sift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports